'use client';

import ContactNew from '@/components/ContactNew';
import FrequentlyAskedQuestions from '@/components/FrequentlyAskedQuestions';
import Testimonials from '@/components/Testimonials';
import { Markdown } from '@/lib/markdown';
import IContactPage from '@/models/contact';

export default function ContactPage(props: { contactPage: IContactPage; preview?: boolean }) {
	const contactPage = props.contactPage;

	return (
		<section className="mt-4">
			{/* <div className="z-20 relative bg-contain xl:bg-cover bg-white text-white bg-bottom flex flex-col">
				<Header
					small
					title={contactPage?.title}
					headerSliderImagesCollection={{ items: [contactPage?.image] }}
				/>
			</div> */}
			<ContactNew imageUrl={contactPage?.image?.url ?? ''} />

			<div className="bg-primary-600 py-16 lg:py-32 bg-[url(/bg-asset.svg)]">
				<div className="w-full flex flex-col lg:flex-row container">
					<div className="w-full lg:w-1/2  text-white flex flex-col justify-center ">
						<div className="flex flex-col gap-8 max-w-[600px]">
							<p className="text-white text-2xl md:text-3xl lg:text-4xl font-bold leading-tight">
								Visit our Corporate Headquarters
							</p>
							<div className="flex flex-col gap-4">
								<Markdown
									className="!gap-0 [&_p]:text-white/80 [&_p]:!mb-0 [&_p]:text-base [&_p]:leading-relaxed"
									content={contactPage?.mapDescription}
								/>
								<a
									href="https://maps.app.goo.gl/wr9g8HLnobxCuJWn6"
									target="_blank"
									rel="noopener noreferrer"
									className="inline-flex items-center gap-2 text-white font-semibold hover:underline w-fit"
								>
									Get directions
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="16"
										height="16"
										viewBox="0 0 24 24"
										fill="none"
										stroke="currentColor"
										strokeWidth="2"
										strokeLinecap="round"
										strokeLinejoin="round"
										aria-hidden="true"
									>
										<path d="M7 17L17 7M17 7H7M17 7v10" />
									</svg>
								</a>
							</div>
						</div>
					</div>
					<iframe
						className="w-full lg:w-1/2 h-[400px] lg:h-[550px] mt-8 lg:mt-0"
						title="location map"
						width="100%"
						height="100%"
						src={contactPage?.mapUrl}
					></iframe>
				</div>
			</div>

			<div className="relative z-20 bg-white">
				<Testimonials />
			</div>
			{/* <div className="overlap-target !overflow-hidden z-20 relative py-12 lg:py-32 flex flex-col gap-8 md:gap-28">
				<Contact
					title={contactPage?.contactTitle}
					description={contactPage?.contactDescription}
				/>
			</div> */}

			{contactPage?.faqsCollection?.items?.length ? (
				<div className="z-10 relative pb-12 -mt-24  md:pb-32 flex flex-col overflow-clip bg-white">
					<FrequentlyAskedQuestions
						faqs={contactPage?.faqsCollection?.items}
						title={'Frequently Asked Questions'}
					/>
				</div>
			) : null}
		</section>
	);
}
